<template>
  <user-create :type="1" />
</template>

<script>
import UserCreate from '@/components/user/Create.vue'

export default {
  name: 'ViewAdminCreate',

  components: { UserCreate }
}
</script>
